import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';
import styles from './index.css';

const NewsList = (props) => {
    const { content } = props;

    return (
        <div>
            {
                content.slice(0, 14).map((item, index) => {
                    return (
                        <div className={styles.newsItem} key={index}>
                            <a href={item.url} target="_blank" rel="noreferrer">
                                <div className={styles.imgWp}><img src={formatImage(getThumbnail(item), 144 * 2, 80 * 2)} alt="" /></div>
                                <div className={styles.textPart}>
                                    <div className={styles.title}>{item.title}</div>
                                    <span className={styles.date}>{item.newsTime}</span>
                                </div>
                            </a>
                        </div>
                    );
                })
            }
        </div>
    );
};

NewsList.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(NewsList);
